// src/utils/darkTheme.js
//
// Single source of truth for dark-mode colors, since this app has no CSS
// files or CSS custom properties at all -- every color decision is made
// inline in JS, and until now dark mode only ever covered the shared
// shell (sidebar/header/page canvas), never actual page content (see the
// comment that used to be in ThemeContext.js: "page content stays on its
// existing light styling for now"). This gives every page a single,
// consistent palette to pull from instead of each one inventing its own
// isDark ? ... : ... values.
//
// Deliberately brighter than a typical muted dark-mode gray scale --
// primary text is near-white (#F8FAFC), not a dimmed mid-gray, per
// explicit request that dark-mode text should stand out clearly rather
// than just being "dark mode technically works." Accent colors get a
// lighter dark-mode variant too (e.g. blue 2563EB -> 60A5FA) since the
// same saturated hex that reads clearly on a white background tends to
// look muddier against a near-black one -- a shade lighter keeps the
// same vibrancy.

export function getThemeColors(isDark) {
  if (!isDark) {
    return {
      isDark: false,
      pageBg: '#F8FAFC', cardBg: '#FFFFFF', cardBgAlt: '#F8FAFC',
      textPrimary: '#0F172A', textSecondary: '#334155', textMuted: '#64748B', textFaint: '#94A3B8',
      border: '#E2E8F0', borderStrong: '#CBD5E1', divider: '#F1F5F9',
      blue: '#2563EB', teal: '#0D9488', purple: '#7C3AED', indigo: '#4F46E5', pink: '#EC4899',
      green: '#16A34A', success: '#10B981', warning: '#D97706', danger: '#DC2626',
      gold: '#CA8A04', sky: '#0EA5E9', orange: '#EA580C', rose: '#E11D48',
    };
  }
  return {
    isDark: true,
    pageBg: '#0B1220', cardBg: '#161E2E', cardBgAlt: '#1E293B',
    textPrimary: '#F8FAFC', textSecondary: '#E2E8F0', textMuted: '#94A3B8', textFaint: '#64748B',
    border: '#334155', borderStrong: '#475569', divider: '#1E293B',
    blue: '#60A5FA', teal: '#2DD4BF', purple: '#A78BFA', indigo: '#818CF8', pink: '#F472B6',
    green: '#4ADE80', success: '#34D399', warning: '#FBBF24', danger: '#F87171',
    gold: '#FACC15', sky: '#38BDF8', orange: '#FB923C', rose: '#FB7185',
  };
}
